import Lenis from '@studio-freight/lenis'
import Rellax from 'rellax';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger.js';

export default function scroll() {

  $( document ).ready(function() {


  gsap.registerPlugin(ScrollTrigger);


  const lenis = new Lenis({
    duration: 3,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: false,
    mouseMultiplier: 1,
    smoothTouch: false,
    touchMultiplier: 2,
    infinite: false,
  })
  
  lenis.on('scroll', ScrollTrigger.update)
  
  gsap.ticker.add((time)=>{
    lenis.raf(time * 1000)
  })
  
  gsap.ticker.lagSmoothing(0)


  $('a[href*="#"]').on('click', function(e) {
    e.preventDefault();
    lenis.stop()	
    $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top - 200,
    }, 500); 
    lenis.start()	
});

  gsap.to(".blueDIV", { opacity: 0.8 })

  const firstone = gsap.timeline({
    scrollTrigger: {
      trigger: ".homsec",
      start: "+=0",
      end: "+=150",
      scrub: true,
    },
  });

  firstone.to(".animboxione", { top: 40 } , 'ff')
  .to(".animboxitwo", { top: 90 } , 'ff')
  .to(".textone", { fontSize: '3.5rem', left: '-150px' } , 'ff')
  .to(".texttwo", { fontSize: '3.5rem' , right: '-90px'} , 'ff')
  .to(".textthree", { fontSize: '1.5rem' , left: '-70px'  } , 'ff')
  .to(".textfour", { fontSize: '1.5rem' , right: '-175px'} , 'ff')
  .to(".blueDIV", { opacity: 0.4 } , 'new')
  .to(".borderanim", { borderColor: '#e7cd9d' }, 'new')
  .to(".scroll", { top: '-80', opacity: 0 }, 'ds')
  .to(".linestart", { height: 0, marginBottom: 0, marginTop: 0 }, 'ds')
  .to(".eye", { opacity: 1 }, 'ds')



          gsap.utils.toArray('.line').forEach(function(line) {
            gsap.to(line, {
              scrollTrigger: {
                trigger: line,              
                start: "40px bottom",
                end: "top top",
                scrub: true, 
              },
              height: 100, 
            });
          });

          gsap.utils.toArray('.key').forEach(function(key) {
            gsap.to(key, {
              scrollTrigger: {
                trigger: key,              
                start: "bottom bottom",
                end: "top top",
                scrub: true, 
              },
              opacity: 1, 
              rotate: 0,
            });
          });
          

          gsap.utils.toArray('.blockone').forEach(function(blockone) {
            gsap.to(blockone, {
              scrollTrigger: {
                trigger: blockone,      
                start: "top bottom",
                end: "top top",
                scrub: true, 
              },
              opacity: 1, 
            });
          });
          
          window.addEventListener("resize", () => {
            ScrollTrigger.refresh();
          });
  


  return new Rellax('.rellax');
});
}



